<section class="tw-relative tw-py-10 tw-bg-[#F8F9FE]">
    <div
        class="tw-relative tw-z-[2] tw-mx-auto tw-px-6 lg:tw-px-20 tw-flex tw-flex-col lg:tw-flex-row tw-gap-4 lg:tw-gap-14 tw-items-center"
    >
        <div class="tw-w-full lg:tw-min-w-[370px] tw-flex-1 md:tw-pr-10">
            <h2
                class="!tw-text-[24px] lg:!tw-text-[30px] !tw-font-bold !tw-text-[#0F3172] !tw-leading-[130%]"
            >
                {{ "NEW_ABOUT_US_SUPPORT.TITLE" | translate }}
            </h2>
            <span
                class="tw-text-[14px] tw-text-[#2A2A2A] tw-font-normal tw-leading-[100%] lg:!tw-leading-[150%]"
            >
                {{ "NEW_ABOUT_US_SUPPORT.DESC" | translate }}
            </span>
        </div>

        <div
            class="tw-hidden tw-w-full tw-flex-[2] md:tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 sm:tw-gap-6 tw-items-stretch"
        >
            <div class="tw-w-full">
                <div
                    class="tw-bg-white tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-h-full tw-cursor-pointer"
                    (click)="scrollToJourney()"
                >
                    <img
                        src="/assets/images/About-us/img1.jpg"
                        alt="Partnership"
                        class="tw-w-full tw-h-[200px] sm:tw-h-[220px] lg:tw-h-[250px] tw-object-cover"
                    />
                    <div
                        class="tw-relative tw-w-full tw-p-3 sm:tw-p-4 tw-bg-[#E5E5E5] tw-shadow-[0_-13px_17px_0_#E5E5E5] tw-flex-1"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold !tw-leading-[100%]"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX1_TITLE" | translate }}
                        </h4>
                        <span
                            class="tw-text-[14px] tw-text-[#2A2A2A] tw-leading-5 tw-font-normal"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX1_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="tw-w-full">
                <div
                    class="tw-bg-white tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-h-full tw-cursor-pointer"
                    (click)="scrollToFinancialAdvisory()"
                >
                    <img
                        src="/assets/images/About-us/img2.jpg"
                        alt="Partnership"
                        class="tw-w-full tw-h-[200px] sm:tw-h-[220px] lg:tw-h-[250px] tw-object-cover"
                    />
                    <div
                        class="tw-relative tw-w-full tw-p-3 sm:tw-p-4 tw-bg-[#E5E5E5] tw-shadow-[0_-13px_17px_0_#E5E5E5] tw-flex-1"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold !tw-leading-[100%]"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX2_TITLE" | translate }}
                        </h4>
                        <span
                            class="tw-text-[14px] tw-text-[#2A2A2A] tw-leading-5 tw-font-normal"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX2_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="tw-w-full">
                <div
                    class="tw-bg-white tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-h-full tw-cursor-pointer"
                    (click)="scrollToGuide()"
                >
                    <img
                        src="/assets/images/About-us/img3.jpg"
                        alt="Partnership"
                        class="tw-w-full tw-h-[200px] sm:tw-h-[220px] lg:tw-h-[250px] tw-object-cover"
                    />
                    <div
                        class="tw-relative tw-w-full tw-p-3 sm:tw-p-4 tw-bg-[#E5E5E5] tw-shadow-[0_-13px_17px_0_#E5E5E5] tw-flex-1"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold !tw-leading-[100%]"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX3_TITLE" | translate }}
                        </h4>
                        <span
                            class="tw-text-[14px] tw-text-[#2A2A2A] tw-leading-5 tw-font-normal"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX3_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="tw-grid tw-w-full tw-flex-[2] md:tw-hidden tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 sm:tw-gap-6"
        >
            <ngx-slick-carousel
                class="carousel what-new"
                [config]="slideConfig"
            >
                <div
                    ngxSlickItem
                    class="tw-bg-white tw-max-w-[290px] tw-mr-[20px] tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-h-full tw-cursor-pointer"
                    (click)="scrollToJourney()"
                >
                    <img
                        src="/assets/images/About-us/img1.jpg"
                        alt="Partnership"
                        class="tw-w-full tw-h-[200px] sm:tw-h-[220px] lg:tw-h-[250px] tw-object-cover"
                    />
                    <div
                        class="tw-relative tw-w-full tw-p-3 sm:tw-p-4 tw-bg-[#E5E5E5] tw-shadow-[0_-13px_17px_0_#E5E5E5] tw-flex-1"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold !tw-leading-[100%]"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX1_TITLE" | translate }}
                        </h4>
                        <span
                            class="tw-text-[14px] tw-text-[#2A2A2A] tw-leading-5 tw-font-normal"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX1_DESC" | translate }}
                        </span>
                    </div>
                </div>

                <div
                    ngxSlickItem
                    class="tw-bg-white tw-max-w-[290px] tw-mr-[20px] tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-h-full tw-cursor-pointer"
                    (click)="scrollToFinancialAdvisory()"
                >
                    <img
                        src="/assets/images/About-us/img2.jpg"
                        alt="Partnership"
                        class="tw-w-full tw-h-[200px] sm:tw-h-[220px] lg:tw-h-[250px] tw-object-cover"
                    />
                    <div
                        class="tw-relative tw-w-full tw-p-3 sm:tw-p-4 tw-bg-[#E5E5E5] tw-shadow-[0_-13px_17px_0_#E5E5E5] tw-flex-1"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold !tw-leading-[100%]"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX2_TITLE" | translate }}
                        </h4>
                        <span
                            class="tw-text-[14px] tw-text-[#2A2A2A] tw-leading-5 tw-font-normal"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX2_DESC" | translate }}
                        </span>
                    </div>
                </div>

                <div
                    ngxSlickItem
                    class="tw-bg-white tw-max-w-[290px] tw-mr-[20px] tw-rounded-[16px] tw-shadow-lg tw-overflow-hidden tw-flex tw-flex-col tw-h-full tw-cursor-pointer"
                    (click)="scrollToGuide()"
                >
                    <img
                        src="/assets/images/About-us/img3.jpg"
                        alt="Partnership"
                        class="tw-w-full tw-h-[200px] sm:tw-h-[220px] lg:tw-h-[250px] tw-object-cover"
                    />
                    <div
                        class="tw-relative tw-w-full tw-p-3 sm:tw-p-4 tw-bg-[#E5E5E5] tw-shadow-[0_-13px_17px_0_#E5E5E5] tw-flex-1"
                    >
                        <h4
                            class="!tw-text-[20px] !tw-text-[#002D86] !tw-underline !tw-font-bold !tw-leading-[100%]"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX3_TITLE" | translate }}
                        </h4>
                        <span
                            class="tw-text-[14px] tw-text-[#2A2A2A] tw-leading-5 tw-font-normal"
                        >
                            {{ "NEW_ABOUT_US_SUPPORT.BOX3_DESC" | translate }}
                        </span>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>
    </div>
</section>
